module.exports = __webpack_public_path__ + "static/click-customize-theme-b6859ddb28204454e6cef477b2f4a5ca.png";